import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, FormLabel } from '@chakra-ui/react';

import DropdownMenu from '../../../../components/DropdownMenu';
import FormInput from '../../../../components/form/FormInput';
import { inputTypes } from '../../../../components/form/FormInput/util';
import LoadingSpinner from '../../../../components/Spinner';
import { analyticsIds } from '../../../../constants/analyticsIds';
import {
  createAutomation,
  getTriggers,
  selectEmailAutomationTriggers
} from '../../../../redux/modules/emailAutomations';
import { hideModal } from '../../../../redux/modules/modal';

const CreateAutomationModal = () => {
  const triggers = useSelector(selectEmailAutomationTriggers);
  const [trigger, setTrigger] = useState(triggers[0]);
  const dispatch = useDispatch();

  const useFormMethods = useForm({
    defaultValues: {
      name: 'Policy/Document Expiration',
      description: 'Send emails before, on, and/or after a policy or document expires',
      trigger_id: triggers[0].id
    }
  });

  const onSubmit = async data => {
    dispatch(createAutomation({ ...data, is_enabled: false }, trigger));
    dispatch(hideModal());
  };

  const {
    handleSubmit,
    formState,
    setValue
  } = useFormMethods;

  if (!triggers || formState.isSubmitting) {
    return <LoadingSpinner isInline />;
  }

  return (
    <form id="create-automation" onSubmit={handleSubmit(onSubmit)}>
      <FormLabel>Trigger Type</FormLabel>

      <DropdownMenu
        useOriginal
        dataAnalyticsKey={analyticsIds.insuredsListPage.createInsuredForm.countryInput}
        labelKey="displayName"
        mt={4}
        name="trigger_id"
        options={triggers}
        placeholder="Select trigger type"
        selected={trigger}
        width="100%"
        onSelect={trigger => {
          setTrigger(trigger);
          setValue('trigger_id', trigger.id);
        }}
      />

      <FormInput
        dataAnalyticsId="email-automation-name"
        inputName="name"
        labelName="Name"
        mt={4}
        placeholder="Automation Name"
        type={inputTypes.standard}
        useFormMethods={useFormMethods}
        validationRules={{
          required: { value: true, message: 'Automation Name is required' },
          maxLength: { value: 64, message: 'Template Name must have fewer than 64 characters' }
        }}
      />

      <FormInput
        dataAnalyticsId="email-automation-description"
        inputName="description"
        labelName="Description"
        mt={4}
        placeholder="Automation Description"
        type={inputTypes.textAreaSm}
        useFormMethods={useFormMethods}
        validationRules={{ maxLength: { value: 255, message: 'Description must have fewer than 64 characters' } }}
      />

      <Button type="submit">Create</Button>
    </form>
  );
};

export default CreateAutomationModal;
